var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlert48Line = function SvgIconAlert48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.728 18.93h-3.4v7.6h3.4v-7.6ZM25.728 28.53h-3.4v3h3.4v-3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.389 38.29h-20.79a5.3 5.3 0 0 1-4.59-7.95l10.4-18a5.31 5.31 0 0 1 9.18 0l10.39 18a5.3 5.3 0 0 1-4.59 7.95Zm-12-24.26-10.39 18a1.9 1.9 0 0 0 1.64 2.85h20.75a1.9 1.9 0 0 0 1.65-2.85l-10.4-18a1.86 1.86 0 0 0-1.64-.94 1.88 1.88 0 0 0-1.61.94Z",
    fill: "current"
  })));
};
export default SvgIconAlert48Line;